var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNewDevice2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_358_43301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3305 24.98H6.33047C4.29047 24.98 2.73047 23.42 2.73047 21.38V4.58C2.73047 2.54 4.29047 0.979996 6.33047 0.979996H18.3305C20.3705 0.979996 21.9305 2.54 21.9305 4.58V21.38C21.9305 23.42 20.3705 24.98 18.3305 24.98ZM6.33047 3.38C5.61047 3.38 5.13047 3.86 5.13047 4.58V21.38C5.13047 22.1 5.61047 22.58 6.33047 22.58H18.3305C19.0505 22.58 19.5305 22.1 19.5305 21.38V4.58C19.5305 3.86 19.0505 3.38 18.3305 3.38H6.33047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3297 20.18C13.6552 20.18 14.7297 19.1055 14.7297 17.78C14.7297 16.4545 13.6552 15.38 12.3297 15.38C11.0042 15.38 9.92969 16.4545 9.92969 17.78C9.92969 19.1055 11.0042 20.18 12.3297 20.18Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_358_43301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.330078 0.979996)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewDevice2);
export default __webpack_public_path__ + "static/media/add_new_device-2.ef3160646e08d74e8b697a04c7dddee8.svg";
export { ForwardRef as ReactComponent };